module.exports = {
  TYPEAHEAD: 'https://www.falabella.com/s/typeahead/v3/{value}?source=web&country={region}',
};
